import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Key, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, fmtError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirm) {
      toast.error("As senhas não coincidem");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, password });
      toast.success("Senha alterada. Entre novamente.");
      navigate("/login");
    } catch (error) {
      toast.error(fmtError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-49px)] flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft size={14} /> Voltar ao login
        </Link>
        <div>
          <Key size={34} weight="duotone" className="text-primary" />
          <div className="label-eyebrow mt-4">nova credencial</div>
          <h1 className="font-display text-4xl font-black tracking-tighter mt-2">Definir nova senha.</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Use pelo menos 15 caracteres. Frases-senha longas são recomendadas.
          </p>
        </div>
        {!token && <div className="border border-destructive text-destructive p-3 text-sm">Link inválido: token ausente.</div>}
        <label className="block">
          <span className="label-eyebrow">nova senha</span>
          <Input type="password" autoComplete="new-password" required minLength={15} maxLength={128}
            value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 rounded-none font-mono-data" />
        </label>
        <label className="block">
          <span className="label-eyebrow">confirmar nova senha</span>
          <Input type="password" autoComplete="new-password" required minLength={15} maxLength={128}
            value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-none font-mono-data" />
        </label>
        <Button type="submit" disabled={loading || !token} className="w-full rounded-none">
          {loading ? "Alterando…" : "Alterar senha"}
        </Button>
      </form>
    </div>
  );
}
